import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/document'

function* fetchDocumentsRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchDocuments'))
  if (fe == null) {
    fe.size = 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_DOCUMENT,
    result,
  })
}

function* fetchDocuments({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchDocuments'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchDocuments', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_DOCUMENT,
    result,
  })
}

function* fetchDocumentEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_DOCUMENT,
    result,
  })
}

function* fetchDocumentSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_DOCUMENT_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_DOCUMENTS,
  })
}

function* fetchDocumentDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_DOCUMENT_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_DOCUMENTS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_DOCUMENTS, fetchDocuments),
    takeEvery(actions.FETCH_DOCUMENT, fetchDocumentEdit),
    takeEvery(actions.SAVE_DOCUMENT, fetchDocumentSave),
    takeEvery(actions.DELETE_DOCUMENT, fetchDocumentDelete),
    takeEvery(actions.RE_FETCH_DOCUMENTS, fetchDocumentsRefresh),
  ])
}
